import BaseballResultsProcessor from '../entities/BaseballResultsProcessor.js';
import { filterOnlyPitches } from '../filters/byResultTypes.js';
import ResultType from '../enums/ResultType.js';
import ResultData from '../enums/ResultData.js';

const getListOfPitchers = function(results, customResultsProcessor){
    let resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let pitchesOnly = resultsProcessor.filterData(results, filterOnlyPitches());
    let resultsMapped = resultsProcessor.mapCollectionProperties(pitchesOnly, [
        [ResultData.TagId.key], [ResultData.PlayerId.key]
    ]);

    let uniquePitchers = [];
    let listOfPitchers = [];

    for (let i = 0; i < resultsMapped.length; i++){
        let singleResult = resultsMapped[i];
        let isTag = false;
        let isPlayer = false;

        isTag = singleResult[ResultData.TagId.key] > 0;
        isPlayer = singleResult[ResultData.PlayerId.key] > 0;
        if(!isTag && !isPlayer){
            continue;
        }

        let pitcherId = isTag ? singleResult[ResultData.TagId.key]: singleResult[ResultData.PlayerId.key];
        let pitcherUniqueId = isTag ? `T${pitcherId}` : `P${pitcherId}`;

        if (uniquePitchers.indexOf(pitcherUniqueId) === -1){
            uniquePitchers.push(pitcherUniqueId);
            listOfPitchers.push({ 
                isTag, id: pitcherId
            });
        }
    }

    return listOfPitchers;
};

const getListOfBatters = function(results, customResultsProcessor){
    let resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let resultsMapped = resultsProcessor.mapCollectionProperties(results, [
        ResultData.TagId.key, ResultData.PlayerId.key, ResultData.Type.key,
        ResultData.BatterTagId.key, ResultData.BatterPlayerId.key
    ]);

    let uniqueBatters = [];
    let listOfBatters = [];

    for (let i = 0; i < resultsMapped.length; i++){
        let singleResult = resultsMapped[i];
        let isTag = false;
        let isPlayer = false;
        let batterId = 0;

        if (singleResult.ResultType === ResultType.Hit.key){
            isTag = singleResult[ResultData.TagId.key] > 0;
            isPlayer = singleResult[ResultData.PlayerId.key] > 0;
            if(!isTag && !isPlayer){
                continue;
            }

            batterId = isTag ? singleResult[ResultData.TagId.key]: singleResult[ResultData.PlayerId.key]
        }
        else if(singleResult.ResultType === ResultType.Pitch.key){
            isTag = singleResult[ResultData.BatterTagId.key] > 0;
            isPlayer = singleResult[ResultData.BatterPlayerId.key] > 0;
            if(!isTag && !isPlayer){
                continue;
            }

            batterId = isTag ? singleResult[ResultData.BatterTagId.key]: singleResult[ResultData.BatterPlayerId.key]
        }

        let batterUniqueId = isTag ? `T${batterId}` : `P${batterId}`;

        if (uniqueBatters.indexOf(batterUniqueId) === -1){
            uniqueBatters.push(batterUniqueId);
            listOfBatters.push({ 
                isTag, id: batterId
            });
        }
    }

    return listOfBatters;
};

export {
    getListOfPitchers, getListOfBatters
};
